var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1994",
    "data-name": "Groupe 1994",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.095,
    height: 47.58,
    viewBox: "0 0 47.095 47.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1930",
    "data-name": "Rectangle 1930",
    width: 47.095,
    height: 47.58,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1707",
    "data-name": "Groupe 1707",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2801",
    "data-name": "Trac\\xE9 2801",
    d: "M47.095,23.789a23.67,23.67,0,0,1-23.547,23.79A23.669,23.669,0,0,1,0,23.789,23.669,23.669,0,0,1,23.547,0a23.67,23.67,0,0,1,23.547,23.79",
    transform: "translate(0 0.001)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2802",
    "data-name": "Trac\\xE9 2802",
    d: "M80.719,126.749a7.887,7.887,0,0,0-5.288-6.561,7.738,7.738,0,0,0-8.249,1.571,7.968,7.968,0,0,0-2.751,6.693,8.236,8.236,0,0,0,7.112,7.737c.772.1.775.1.688.9-.006.061-.019.122-.027.183a36.437,36.437,0,0,1-.909,4.21c-.247.952-.516,1.9-.786,2.889,1.975,0,3.9,0,5.833,0,.194,0,.26-.123.343-.253a16.609,16.609,0,0,0,1.02-1.867,33.144,33.144,0,0,0,2.9-10.421,19.061,19.061,0,0,0,.113-5.089m-2.682,1.3c-.008.34,0,.681,0,1.021a31.5,31.5,0,0,1-2.906,12.086c-.128.272-.254.455-.607.428-.3-.023-.353-.095-.28-.389a29.265,29.265,0,0,0,.728-3.633,7.184,7.184,0,0,0-.026-2.035,2.28,2.28,0,0,0-2.392-2.1,5.47,5.47,0,1,1,5.484-5.38",
    transform: "translate(-58.349 -108.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2803",
    "data-name": "Trac\\xE9 2803",
    d: "M104.641,155.351c-.008.34,0,.681,0,1.021a31.5,31.5,0,0,1-2.906,12.086c-.128.272-.254.455-.607.428-.3-.023-.353-.094-.28-.389a29.272,29.272,0,0,0,.728-3.633,7.185,7.185,0,0,0-.026-2.035,2.28,2.28,0,0,0-2.392-2.1,5.47,5.47,0,1,1,5.484-5.38",
    transform: "translate(-84.953 -135.542)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2804",
    "data-name": "Trac\\xE9 2804",
    d: "M301.726,155.351c-.008.34,0,.681,0,1.021a31.5,31.5,0,0,1-2.906,12.086c-.128.272-.254.455-.607.428-.3-.023-.353-.094-.28-.389a29.251,29.251,0,0,0,.728-3.633,7.187,7.187,0,0,0-.026-2.035,2.28,2.28,0,0,0-2.392-2.1,5.47,5.47,0,1,1,5.484-5.38",
    transform: "translate(-263.473 -135.542)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2805",
    "data-name": "Trac\\xE9 2805",
    d: "M277.8,126.749a7.887,7.887,0,0,0-5.288-6.561,7.738,7.738,0,0,0-8.249,1.571,7.968,7.968,0,0,0-2.751,6.693,8.236,8.236,0,0,0,7.112,7.737c.772.1.775.1.688.9-.006.061-.019.122-.027.183a36.436,36.436,0,0,1-.909,4.21c-.247.952-.516,1.9-.786,2.889,1.975,0,3.9,0,5.833,0,.194,0,.26-.123.343-.253a16.608,16.608,0,0,0,1.02-1.867,33.145,33.145,0,0,0,2.9-10.421,19.066,19.066,0,0,0,.113-5.089m-2.682,1.3c-.008.34,0,.681,0,1.021a31.5,31.5,0,0,1-2.906,12.086c-.128.272-.254.455-.607.428-.3-.023-.353-.095-.28-.389a29.269,29.269,0,0,0,.728-3.633,7.186,7.186,0,0,0-.026-2.035,2.28,2.28,0,0,0-2.392-2.1,5.47,5.47,0,1,1,5.484-5.38",
    transform: "translate(-236.869 -108.242)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.91dca9c63fed1be511658d64a9809e1e.svg";
export { ForwardRef as ReactComponent };